// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Jvb","icon":"e_Kvb"};